import { Media } from './Media';
import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Files } from '@phosphor-icons/react';
import { MediaView } from "./MediaView";
import { MediaFiles } from "./widgets/MediaFiles";

// Launch Media shows with the "media" permission, or for admins (like Launch Reviews)
const canSee = (permissions: string[] = []) => permissions.includes("media") || permissions.includes("admin");

export const onListItems = (hook: HookObject, payload: any, __: any, { permissions = [] }: { permissions?: string[] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!canSee(permissions)) return [];
    return [
      {
        route: "/media",
        icon: <Files className="text-lg" />,
        label: "Launch Media",
        href: "/media",
        order: 4,
      },
    ];
  }

  // SM-7: the dashboard widget (a campaign's files; hidden until a dashboard turns it on)
  if (hook.id === ListItemsHooks.WIDGET && hook.type === "media") {
    if (!canSee(permissions)) return [];
    return <MediaFiles {...(payload?.settings || {})} />;
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!canSee(permissions)) return [];
    return [
      {
        path: "/media",
        element: <Media name="Launch Media" />,
        children: [
          {
            path: ":id",
            element: <MediaView name="Media" />,
          },
        ],
      },
    ];
  }
};

export { Media };